import { Link } from '../app/Link'
import { openQuickAdd } from '../screens/QuickAdd'
import { PenIcon, PipelineIcon, PlusIcon, SearchIcon } from './icons'
import './bottom-bar.css'

const TABS = [
  { to: '/', label: 'Pipeline', icon: PipelineIcon },
  { to: '/linkedin', label: 'LinkedIn', icon: PenIcon },
  { to: '/search', label: 'Search', icon: SearchIcon },
] as const

/**
 * Three places and one action: the pipeline, the LinkedIn writing list,
 * search, and a new idea. The tabs sit in a floating pill, as in Linear's
 * mobile app; the `+` is its own raised button beside it, the thing a thumb
 * reaches for without looking.
 *
 * On a laptop there is no thumb and a pill floating over the list only hides
 * rows, so from 900px the same markup becomes a rail down the left edge.
 */
export function BottomBar({ current }: { current: '/' | '/linkedin' | '/search' | null }) {
  return (
    <div className="bottom-bar">
      <nav className="bottom-tabs" aria-label="Main">
        {TABS.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="bottom-tab"
            aria-current={current === to ? 'page' : undefined}
          >
            <Icon size={22} />
            <span>{label}</span>
          </Link>
        ))}
      </nav>
      <button
        type="button"
        className="bottom-add"
        aria-label="New idea"
        // From the LinkedIn list, the new idea is a LinkedIn topic.
        onClick={() => openQuickAdd('idea', current === '/linkedin' ? 'linkedin' : undefined)}
      >
        <PlusIcon size={26} strokeWidth={2.2} />
        <span className="bottom-add-label">New idea</span>
        <kbd className="bottom-add-key">N</kbd>
      </button>
    </div>
  )
}
